module.exports = __webpack_public_path__ + "static/img/contant_4.6172893.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_9/contant_4.png
// module id = S1iI
// module chunks = 0